import { api } from './api';

export type SsoProvider = 'saml' | 'oidc';

export interface SsoConfig {
  id: string;
  companyId: string;
  provider: SsoProvider;
  displayName: string;
  entryPoint: string;
  identifier: string;
  emailDomain: string | null;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSsoConfigDto {
  provider: SsoProvider;
  displayName: string;
  entryPoint: string;
  identifier: string;
  secret: string;
  emailDomain?: string | null;
}

export const ssoApi = {
  async list(companyId: string): Promise<SsoConfig[]> {
    const r = await api.get<SsoConfig[]>(`/api/companies/${companyId}/sso-configs`);
    return r.data;
  },
  async create(companyId: string, dto: CreateSsoConfigDto): Promise<SsoConfig> {
    const r = await api.post<SsoConfig>(`/api/companies/${companyId}/sso-configs`, dto);
    return r.data;
  },
  async remove(companyId: string, id: string): Promise<{ ok: boolean }> {
    const r = await api.delete<{ ok: boolean }>(`/api/companies/${companyId}/sso-configs/${id}`);
    return r.data;
  },
  async discover(email: string): Promise<{ configId: string; entryPoint: string; displayName: string; provider: SsoProvider } | null> {
    const r = await api.get(`/api/sso/discover`, { params: { email } });
    return r.data;
  },
  loginUrl(configId: string): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/sso/login?config=${encodeURIComponent(configId)}`;
  },
  metadataUrl(): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/sso/saml/metadata`;
  },
};
